import { treatmentZodSchema } from "@redotech/redo-storefront-widget-common/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTreatments = {
  name: "getTreatments" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({ treatments: z.array(treatmentZodSchema) }),
};
